
import { Vue, Component, Watch, Prop, Emit } from "vue-property-decorator";
import html2canvas from "html2canvas";
import { ModalType, Settings } from "@/constant";
import { isIOS, isMobile, isTablet } from "mobile-device-detect";
import PlusCircleIcon from "@/assets/icons/PlusCircle.vue";
import MinusCircleIcon from "@/assets/icons/MinusCircle.vue";
import Loader from "../Loader.vue";
import {
  closeDragElement,
  fitSVGToModal,
  getTransformMatrix,
  normalZoomIn,
  tranformOriginOfElement,
} from "@/core";

@Component({
  components: {
    PlusCircleIcon,
    MinusCircleIcon,
    Loader
  },
})
export default class PlatMapPrintModal extends Vue {
  [x: string]: any;
  @Prop() private isOpenPrintModal: boolean;
  @Prop() private underlay_on: boolean;

  $elmnt: HTMLElement;
  private clonedSVG: any = "";
  private pos1 = 0;
  private pos2 = 0;
  private pos3 = 0;
  private pos4 = 0;
  private evCache: any = [];
  private prevDiff = -1;
  private isDisabledZoomIn = false;
  private isDisabledZoomOut = false;
  private loading = false;
  private svgZoom = 1;
  @Emit("closeModal") closeModal(modalName: string) {}

  @Emit("printPDF") printPDF(platmap: string) {
    this.resetTransform();
  }

  @Watch("isOpenPrintModal") renderSVG(value) {
    if (value) {
      this.renderSvg();
    }
  }
  @Watch("isDisabledZoomIn") disableZoomIn() {
    let zoomIn = document.querySelector(
      "#print-modal-zoom-in"
    ) as HTMLDivElement;
    if (this.isDisabledZoomIn) {
      zoomIn.style.pointerEvents = "none";
      zoomIn.style.opacity = "0.5";
    } else {
      zoomIn.style.pointerEvents = "auto";
      zoomIn.style.opacity = "1";
    }
  }
  @Watch("isDisabledZoomOut") disableZoomOut() {
    let zoomOut = document.querySelector(
      "#print-modal-zoom-out"
    ) as HTMLDivElement;
    if (this.isDisabledZoomOut) {
      zoomOut.style.pointerEvents = "none";
      zoomOut.style.opacity = "0.5";
    } else {
      zoomOut.style.pointerEvents = "auto";
      zoomOut.style.opacity = "1";
    }
  }
  renderSvg() {
    let element = document.getElementById("plan-overlay") as HTMLElement;
    if (this.underlay_on) {
      element = document.getElementById("map") as HTMLElement;
    }
    let svg = element.getElementsByTagName("svg")[0];
    const clone = svg.cloneNode(true) as HTMLElement;
    clone.id = "print-modal-svg";
    this.clonedSVG = clone?.outerHTML;

    setTimeout(() => {
      const overlayContainer = document.querySelector("#crop") as HTMLElement;
      this.$elmnt = overlayContainer;
      this.isDisabledZoomOut = true;
      fitSVGToModal(this.svgZoom);

      if (isMobile || isTablet || isIOS) {
        overlayContainer.ontouchstart = this.dragMouseDown;
      } else {
        overlayContainer.onmousedown = this.dragMouseDown;
      }
      this.touchWheelEvents(overlayContainer);
    }, 1000);
  }

  scrollCallback(e) {
    e.preventDefault();
    let delta = (e.deltaY || -e.wheelDelta || e.detail) >> 10 || 1;
    this.svgZoomIn(e.wheelDelta > 0 ? 0.5 : -0.5);
  }
  svgZoomIn(zoomStep = 1) {
    this.zoomIn(zoomStep);
  }
  svgZoomOut(zoomStep = 1) {
    this.svgZoomIn(zoomStep * -1);
  }
  zoomIn(zoomStep) {
    const zoomParams = normalZoomIn(this.svgZoom, zoomStep);
    const svg = document.getElementById("crop")?.getElementsByTagName("svg")[0];
    this.isDisabledZoomIn = zoomParams.isDisabledZoomIn;
    this.isDisabledZoomOut = zoomParams.isDisabledZoomOut;
    this.svgZoom = zoomParams.svgZoom;
    tranformOriginOfElement(svg, this.svgZoom, this.svgZoom);
  }

  touchWheelEvents(overlayContainer) {
    if ("ontouchstart" in window) {
      this.initPinchInPinchOut(overlayContainer);
    } else {
      overlayContainer.addEventListener(
        "mousewheel",
        (e) => {
          this.scrollCallback(e);
        },
        {
          passive: false,
        }
      );
      overlayContainer.addEventListener(
        "DOMMouseScroll",
        (e) => {
          this.scrollCallback(e);
        },
        {
          passive: false,
        }
      );
    }
  }
  initPinchInPinchOut(el) {
    el.onpointerdown = this.pointerdown_handler;
    el.onpointermove = this.pointermove_handler;
    el.onpointerup = this.pointerup_handler;
    el.onpointercancel = this.pointerup_handler;
    el.onpointerout = this.pointerup_handler;
    el.onpointerleave = this.pointerup_handler;
  }
  pointerdown_handler(ev) {
    this.evCache.push(ev);
  }
  callZoom(curDiff) {
    if (this.prevDiff > 0) {
      if (curDiff > this.prevDiff) {
        this.svgZoomIn(0.02);
      }
      if (curDiff < this.prevDiff) {
        this.svgZoomOut(0.02);
      }
    }
  }
  pointermove_handler(ev) {
    for (let i = 0; i < this.evCache.length; i++) {
      if (ev.pointerId == this.evCache[i].pointerId) {
        this.evCache[i] = ev;
        break;
      }
    }
    if (this.evCache.length == 2) {
      let curDiff = Math.abs(this.evCache[0].clientX - this.evCache[1].clientX);
      this.callZoom(curDiff);
      this.prevDiff = curDiff;
    } else {
      this.prevDiff = -1;
    }
  }

  pointerup_handler(ev) {
    this.remove_event(ev);
    if (this.evCache.length < 2) {
      this.prevDiff = -1;
    }
  }
  remove_event(ev) {
    for (let i = 0; i < this.evCache.length; i++) {
      if (this.evCache[i].pointerId == ev.pointerId) {
        this.evCache.splice(i, 1);
        break;
      }
    }
  }

  dragMouseDown(e) {
    e = e || window.event;
    if (isMobile) {
      const touch = e.touches[0] || e.changedTouches[0];
      this.pos3 = touch.clientX;
      this.pos4 = touch.clientY;
      document.ontouchend = closeDragElement;
      document.ontouchmove = this.elementDrag;
    } else {
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = this.elementDrag;
    }
  }

  elementDrag(e) {
    e = e || window.event;
    if (isMobile) {
      const touch = e.touches[0] || e.changedTouches[0];
      this.pos1 = this.pos3 - touch.clientX;
      this.pos2 = this.pos4 - touch.clientY;
      this.pos3 = touch.clientX;
      this.pos4 = touch.clientY;
    } else {
      this.pos1 = this.pos3 - e.clientX;
      this.pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
    }
    if (this.$elmnt) {
      this.$elmnt.style.top = this.$elmnt.offsetTop - this.pos2 + "px";
      this.$elmnt.style.left = this.$elmnt.offsetLeft - this.pos1 + "px";
    }
  }

  resetTransform() {
    this.clonedSVG = "";
    this.pos1 = 0;
    this.pos2 = 0;
    this.pos3 = 0;
    this.pos4 = 0;
    this.loading = false;
    this.evCache = [];
    this.prevDiff = -1;
    this.isDisabledZoomIn = false;
    this.isDisabledZoomOut = false;
    this.svgZoom = 1;
  }
  closePrintModal() {
    this.resetTransform();
    this.closeModal(ModalType.CROPPING_TOOL);
  }
  printMap() {
    this.loading = true;
    const loadTimer = setTimeout(() => {
      const element = document.getElementById("crop") as HTMLElement;
      const rect = element.getBoundingClientRect();
      const x = rect.x.toFixed(2);
      const y = rect.y.toFixed(2);

      window.scrollTo(0, 0);
      html2canvas(element, {
        height: element.offsetHeight,
        width: element.offsetWidth,
        logging: false,
        imageTimeout: 0,
        useCORS: true,
        foreignObjectRendering: true,
        x: -x,
        y: -y,
        scrollX: 0,
        scrollY: 0,
        allowTaint: true,
      }).then((canvas) => {
        const base64 = canvas.toDataURL("image/jpeg", 0.9);
        this.printPDF(base64);
        this.loading = false;
      });
      clearTimeout(loadTimer);
    }, 100);
  }
}
